// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"filter-panel-menu__visuallyhidden--erchx","focusable":"filter-panel-menu__focusable--wEG15","options":"filter-panel-menu__options--SAPFg"};